module.exports = __webpack_public_path__ + "static/media/9s.7511217b.png";